import React, { Suspense, lazy } from "react";
import { useLocation } from "react-router-dom";
import { Link, Route, Switch } from "react-router-dom";
import ImgLoaded from "../../Components/Imgloaded/Imgloaded";
import Footer from "../Footer/Footer";
import { Navbar } from "../Navbar/Navbar";
import "./Body.css";

const About = lazy(() => import("./Pages/About"));
const Contact = lazy(() => import("./Pages/Contact"));
const Home = lazy(() => import("./Pages/Home"));
const News = lazy(() => import("./Pages/News"));
const Projects = lazy(() => import("./Pages/Projects"));
const Publications = lazy(() => import("./Pages/Publications"));

const Body = () => {

  const location = useLocation()
  const isHome = location.pathname === '/' ? true : false
  return (
  <>
  <Navbar isHome={isHome}/>
    <main id="main-content" className="body">
      <Suspense fallback={<div className="loading" aria-live="polite" aria-label="Loading page"><i className="fa fa-spinner fa-spin" aria-hidden="true" /></div>}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path={'/projects'} component={Projects}/>
          <Route exact path={'/news'} component={News} />
          <Route exact path={'/publications'} component={Publications} />
          <Route exact path={'/about'} component={About} />
          <Route exact path={'/contact'} component={Contact} />
            <Route>
            <div className="body__404">
              <div className="404content">
                <h1>404</h1>
                <p>Page not found</p>
                <Link to="/" className="appbtn">Go to Home</Link>
              </div>
              <ImgLoaded img='https://mcusercontent.com/013dcbdd2fe47e8cd211361cd/images/c0698712-100c-3f16-357a-dc4c566e06eb.jpg' alt=""/>
            </div>
          </Route>
        </Switch>
      </Suspense>
    </main>
    {!isHome && <Footer />}
    </>
  );
};
export default Body;
